import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import {
   Box,
   Card,
   CardContent,
   Dialog,
   DialogContent,
   DialogTitle,
   Fab,
   Typography,
   Avatar,
} from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import Grid from '@mui/material/Grid';
import { FlagsContainer, FrenchFlag, EnglishFlag, GermanFlag } from '../flags/Flags';
import CamilleDouay from '../../images/contact_images/CamilleDouay.png';
import MaximeDegrelle from '../../images/contact_images/MaximeDegrelle.png';
import MelanieArcicasa from '../../images/contact_images/MelanieArcicasa.png';
import PaulFliegans from '../../images/contact_images/PaulFliegans.png';

export const SpeechButton = () => {
   const [open, setOpen] = useState(false);
   const { t } = useTranslation();

   return (
      <>
         {/* Floating Speech button */}
         <Fab
            variant="extended"
            onClick={() => setOpen(true)}
            sx={{
               visibility: open ? 'hidden' : 'visible',
               position: 'fixed',
               bottom: '6rem',
               left: '50%',
               transform: 'translateX(-50%)',
               zIndex: 1000,
               bgcolor: '#A98DC6DD',
               color: 'white',
               fontWeight: 'bold',
               paddingX: '2rem',
               minWidth: '280px',
               '&:hover': {
                  bgcolor: '#8B75A8',
               },
            }}
         >
            {t('useful.participate.button')}
         </Fab>

         {/* Modal */}
         <Dialog
            open={open}
            onClose={() => setOpen(false)}
            maxWidth="md"
            fullWidth
            slotProps={{
               paper: {
                  sx: {
                     bgcolor: '#4A3A5A',
                     color: 'white',
                  },
               },
            }}
         >
            <DialogTitle sx={{ color: 'white' }}>{t('useful.participate.title')}</DialogTitle>
            <DialogContent>
               <Box sx={{ padding: 2 }}>
                  <Typography variant="body1" sx={{ marginBottom: 3, color: 'white' }}>
                     {t('useful.participate.description')}
                  </Typography>

                  <Grid container spacing={6}>
                     {/* Camille */}
                     <Grid size={{ xs: 12, sm: 6 }}>
                        <Card
                           sx={{
                              textAlign: 'center',
                              padding: 2,
                              height: '100%',
                              boxShadow: 3,
                              '&:hover': { boxShadow: 6 },
                              position: 'relative',
                              overflow: 'visible',
                           }}
                        >
                           {/* Language Ribbons */}
                           <FlagsContainer>
                              <FrenchFlag />
                              <EnglishFlag />
                           </FlagsContainer>

                           <Avatar
                              src={CamilleDouay}
                              alt="Camille Douay"
                              sx={{ width: 100, height: 100, margin: '0 auto', marginBottom: 2 }}
                           />
                           <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Camille Douay
                              </Typography>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    mb: 1,
                                 }}
                              >
                                 <PhoneIcon fontSize="small" color="action" />
                                 <Typography variant="body2" color="text.secondary">
                                    +33 6 12 34 56 78
                                 </Typography>
                              </Box>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                 }}
                              >
                                 <EmailIcon fontSize="small" color="action" />
                                 <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ wordBreak: 'break-word' }}
                                 >
                                    camille.douay5@gmail.com
                                 </Typography>
                              </Box>
                           </CardContent>
                        </Card>
                     </Grid>

                     {/* Paul */}
                     <Grid size={{ xs: 12, sm: 6 }}>
                        <Card
                           sx={{
                              textAlign: 'center',
                              padding: 2,
                              height: '100%',
                              boxShadow: 3,
                              '&:hover': { boxShadow: 6 },
                              position: 'relative',
                              overflow: 'visible',
                           }}
                        >
                           {/* Language Ribbons */}
                           <FlagsContainer>
                              <FrenchFlag />
                              <EnglishFlag />
                              <GermanFlag />
                           </FlagsContainer>

                           <Avatar
                              src={PaulFliegans}
                              alt="Paul Fliegans"
                              sx={{ width: 100, height: 100, margin: '0 auto', marginBottom: 2 }}
                           />
                           <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Paul Fliegans
                              </Typography>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    mb: 1,
                                 }}
                              >
                                 <PhoneIcon fontSize="small" color="action" />
                                 <Typography variant="body2" color="text.secondary">
                                    +49 176 20222785
                                 </Typography>
                              </Box>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                 }}
                              >
                                 <EmailIcon fontSize="small" color="action" />
                                 <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ wordBreak: 'break-word' }}
                                 >
                                    paul.fliegans@gmail.com
                                 </Typography>
                              </Box>
                           </CardContent>
                        </Card>
                     </Grid>

                     {/* Mel */}
                     <Grid size={{ xs: 12, sm: 6 }}>
                        <Card
                           sx={{
                              textAlign: 'center',
                              padding: 2,
                              height: '100%',
                              boxShadow: 3,
                              '&:hover': { boxShadow: 6 },
                              position: 'relative',
                              overflow: 'visible',
                           }}
                        >
                           {/* Language Ribbons */}
                           <FlagsContainer>
                              <FrenchFlag />
                              <EnglishFlag />
                           </FlagsContainer>

                           <Avatar
                              src={MelanieArcicasa}
                              alt="Mélanie Arcicasa"
                              sx={{ width: 100, height: 100, margin: '0 auto', marginBottom: 2 }}
                           />
                           <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Mélanie Arcicasa
                              </Typography>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    mb: 1,
                                 }}
                              >
                                 <PhoneIcon fontSize="small" color="action" />
                                 <Typography variant="body2" color="text.secondary">
                                    +33 6 34 56 78 90
                                 </Typography>
                              </Box>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                 }}
                              >
                                 <EmailIcon fontSize="small" color="action" />
                                 <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ wordBreak: 'break-word' }}
                                 >
                                    melanie.arcicasa@gmail.com
                                 </Typography>
                              </Box>
                           </CardContent>
                        </Card>
                     </Grid>

                     {/* Max */}
                     <Grid size={{ xs: 12, sm: 6 }}>
                        <Card
                           sx={{
                              textAlign: 'center',
                              padding: 2,
                              height: '100%',
                              boxShadow: 3,
                              '&:hover': { boxShadow: 6 },
                              position: 'relative',
                              overflow: 'visible',
                           }}
                        >
                           {/* Language Ribbons */}
                           <FlagsContainer>
                              <FrenchFlag />
                           </FlagsContainer>

                           <Avatar
                              src={MaximeDegrelle}
                              alt="Maxime Degrelle"
                              sx={{ width: 100, height: 100, margin: '0 auto', marginBottom: 2 }}
                           />
                           <CardContent>
                              <Typography variant="h6" gutterBottom>
                                 Maxime Degrelle
                              </Typography>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                    mb: 1,
                                 }}
                              >
                                 <PhoneIcon fontSize="small" color="action" />
                                 <Typography variant="body2" color="text.secondary">
                                    +33 6 33 24 84 21
                                 </Typography>
                              </Box>
                              <Box
                                 sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 1,
                                 }}
                              >
                                 <EmailIcon fontSize="small" color="action" />
                                 <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    sx={{ wordBreak: 'break-word' }}
                                 >
                                    maxime.degrelle95@hotmail.fr
                                 </Typography>
                              </Box>
                           </CardContent>
                        </Card>
                     </Grid>
                  </Grid>
               </Box>
            </DialogContent>
         </Dialog>
      </>
   );
};
